import { useMutation } from "@apollo/client";
import { REMOVE_DOC_FROM_REFERRAL } from "../../mutations/referrals";
import { enqueueSnackbar } from "../../state/ducks/notifiers";
import { useDispatch } from "react-redux";
import { hydrateDialogReferral } from "../../state/ducks/editDialog";
import useFetchReferral from "../useFetchReferral";

const useRemoveDocumentFromReferral = () => {
  const dispatch = useDispatch();
  const { handleFetchReferral } = useFetchReferral();
  const [removeDocFromReferral] = useMutation(REMOVE_DOC_FROM_REFERRAL, {
    onCompleted: async (data, { variables }) => {
      const { doc, referral } = variables;
      dispatch(
        enqueueSnackbar({
          message: `Removed document ${doc?.filename} from REF-${referral.displayableId}`,
          options: {
            variant: "success",
          },
        })
      );
      const refreshedReferral = await handleFetchReferral(referral.id, {
        inspectReferral: true,
        cardDetail: false,
        fetchPolicy: "network-only",
      });
      if (refreshedReferral) {
        dispatch(hydrateDialogReferral(refreshedReferral));
      }
    },
    onError: (error, { variables }) => {
      const { doc } = variables;
      dispatch(
        enqueueSnackbar({
          message: `Failed to delete document ${doc?.filename}`,
          options: {
            variant: "error",
          },
        })
      );
    },
  });

  const removeDocumentFromReferral = async (doc, referral, clientId) => {
    return await removeDocFromReferral({
      variables: {
        clientId,
        processInstanceId: referral.id,
        documentId: doc.uuid,
        doc, // Pass the doc object
        referral, // Pass the referral object
      },
    });
  };

  return { removeDocumentFromReferral };
};

export default useRemoveDocumentFromReferral;
